import React from 'react';
import './GalleryPhotosPage.css';
import gallery1 from '../images/gallery-1.jpeg';
import gallery2 from '../images/gallery-2.jpeg';
import gallery3 from '../images/gallery-3.jpeg';
import gallery4 from '../images/gallery-4.jpeg';

import gallery7 from '../images/gallery-7.jpeg';
import gallery8 from '../images/gallery-8.jpeg';
import gallery9 from '../images/gallery-9.jpeg';

const galleryImages = [gallery1, gallery2, gallery3,gallery4, gallery7, gallery8, gallery9];

export default function GalleryPhotosPage() {
  return (
    <section className="gallery-page">
      <div className="gallery-page__container">
        <h1 className="gallery-page__title">Photos</h1>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <article key={`gallery-${index + 1}`} className="gallery-grid__item">
              <img src={image} alt={`Gallery ${index + 1}`} loading="lazy" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
